const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';
/* eslint-disable */

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectProduct: $('.js-products-block__wrap-select'),
	$domResetFiltersButton: $('.js-product-block__filters-link'),
	$domResetFiltersLinks: $('.js-products-block__wrap-select'),
	clearingFilter: true,

	/** @description Initialize */
	init: function () {
		this.select2();
		this.resetAllFilters();
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */

		Select2.select2Positioning();

		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
			placeholder: 'Select',
			allowClear: true,
			dropdownPosition: 'below'
		});

		Select2.$selectProduct.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'products-block__wrap-select',
			placeholder: 'Select',
			allowClear: true,
			dropdownPosition: 'below'
		});
	},

	// This adds the option "dropdownPosition" to select2
	select2Positioning: () => {
		var Defaults = $.fn.select2.amd.require('select2/defaults');

		$.extend(Defaults.defaults, {
			dropdownPosition: 'auto'
		});

		var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');
		var _positionDropdown = AttachBody.prototype._positionDropdown;

		AttachBody.prototype._positionDropdown = function () {

			var $window = $(window);
			var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
			var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
			var newDirection = null;
			var offset = this.$container.offset();

			offset.bottom = offset.top + this.$container.outerHeight(false);

			var container = {
				height: this.$container.outerHeight(false)
			};

			container.top = offset.top;
			container.bottom = offset.top + container.height;

			var dropdown = {
				height: this.$dropdown.outerHeight(false)
			};
			var viewport = {
				top: $window.scrollTop(),
				bottom: $window.scrollTop() + $window.height()
			};
			var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
			var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
			var css = {
				left: offset.left,
				top: container.bottom
			};
			// Determine what the parent element is to use for calciulating the offset
			var $offsetParent = this.$dropdownParent;
			// For statically positoned elements, we need to get the element
			// that is determining the offset
			if ($offsetParent.css('position') === 'static') {
				$offsetParent = $offsetParent.offsetParent();
			}

			var parentOffset = $offsetParent.offset();

			css.top -= parentOffset.top
			css.left -= parentOffset.left;

			var dropdownPositionOption = this.options.get('dropdownPosition');

			if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {
				newDirection = dropdownPositionOption;
			} else {
				if (!isCurrentlyAbove && !isCurrentlyBelow) {
					newDirection = 'below';
				}

				if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
					newDirection = 'above';
				} else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
					newDirection = 'below';
				}
			}

			if (newDirection == 'above' ||
				(isCurrentlyAbove && newDirection !== 'below')) {
				css.top = container.top - parentOffset.top - dropdown.height;
			}

			if (newDirection != null) {
				this.$dropdown
					.removeClass('select2-dropdown--below select2-dropdown--above')
					.addClass('select2-dropdown--' + newDirection);
				this.$container
					.removeClass('select2-container--below select2-container--above')
					.addClass('select2-container--' + newDirection);
			}

			this.$dropdownContainer.css(css);
		};

	},

	resetAllFilters: function () {
		Select2.$domResetFiltersButton.on('click', function () {
			Select2.clearingFilter = false;
			Select2.$domResetFiltersLinks.val(null).trigger('change');
			$('.product-block__filters--loader-icon').addClass('is-active');

			$('body').removeClass('category');
			$('.products__button').hide();
			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: fwsLocalized.ajaxUrl,
				data: {
					action: 'show_products',
				},
				success: function (response) {
					$('.product-block__filters--loader-icon').removeClass('is-active');
					$('.js-post-wrap').empty();
					$('.js-category-resource-wrap').append(response.htmlPosts);
					$('.products__button').show();
					if (response.count_posts > 12) {
						$('.js-load-more').removeClass('hidden');
					} else {
						$('.js-load-more').addClass('hidden');
					}
				}
			});
			Select2.clearingFilter = true;
		});
	}
};

export default Select2;
